import styled from 'styled-components';

export const CenterContent = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h3 {
    text-align: center;
  }

  form {
    label {
      margin: 10px 0;
    }

    .account {
      margin: 10px 0;
      a {
        color: #007bff;
      }
    }
  }
`;
